<template>
<div class="chapter">
<div class="inner_page">
<div class="SOM">
<div class="SOM_titre">Contents</div>
<div class="SOM_pre"><a href="#/pre2">Preface</a></div>
<div class="SOM_chap"><a href="#/chap1">1 EVIL IS STILL A FOUR-LETTER WORD: The New Problem of Evil</a></div>
<div class="SOM_niv1"><a href="#/chap1#niv1-001">The New Problem of Evil</a></div>
<div class="SOM_niv1"><a href="#/chap1#niv1-002">The New Nihilism: Postmodernity</a></div>
<div class="SOM_niv1"><a href="#/chap1#niv1-003">Toward a Nuanced View of Evil</a></div>
<div class="SOM_niv1"><a href="#/chap1#niv1-004">Conclusion</a></div>
<div class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample">2 WHAT CAN GOD DO ABOUT EVIL? Unjust World, Just God?</span></div>
<div class="SOM_niv1"><span href="#/chap2#niv1-005" title="Link target outside of Sample">To Renew the Blessing</span></div>
<div class="SOM_niv1"><span href="#/chap2#niv1-006" title="Link target outside of Sample">People of the Solution, People of the Problem</span></div>
<div class="SOM_niv1"><span href="#/chap2#niv1-007" title="Link target outside of Sample">My Servant Israel, My Servant Job</span></div>
<div class="SOM_niv1"><span href="#/chap2#niv1-008" title="Link target outside of Sample">Conclusion</span></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample">3 EVIL AND THE CRUCIFIED GOD</span></div>
<div class="SOM_niv1"><span href="#/chap3#niv1-009" title="Link target outside of Sample">Rereading the Gospels</span></div>
<div class="SOM_niv1"><span href="#/chap3#niv1-010" title="Link target outside of Sample">Jesus Dealing with Evil</span></div>
<div class="SOM_niv1"><span href="#/chap3#niv1-011" title="Link target outside of Sample">Early Christian View of Evil’s Defeat</span></div>
<div class="SOM_niv1"><span href="#/chap3#niv1-012" title="Link target outside of Sample">Results: Atonement and the Problem of Evil</span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample">4 IMAGINE THERE’S NO EVIL: God’s Promise of a World Set Free</span></div>
<div class="SOM_niv1"><span href="#/chap4#niv1-013" title="Link target outside of Sample">Interlude: Naming the Powers</span></div>
<div class="SOM_niv1"><span href="#/chap4#niv1-014" title="Link target outside of Sample">World Without Evil</span></div>
<div class="SOM_niv1"><span href="#/chap4#niv1-015" title="Link target outside of Sample">The Intermediate Tasks</span></div>
<div class="SOM_niv1"><span href="#/chap4#niv1-016" title="Link target outside of Sample">Educating the Imagination</span></div>
<div class="SOM_niv1"><span href="#/chap4#niv1-017" title="Link target outside of Sample">Conclusion</span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample">5 DELIVER US FROM EVIL: Forgiving Myself, Forgiving Others</span></div>
<div class="SOM_niv1"><span href="#/chap5#niv1-018" title="Link target outside of Sample">God’s Final Victory over Evil</span></div>
<div class="SOM_niv1"><span href="#/chap5#niv1-019" title="Link target outside of Sample">Forgiveness in the Present</span></div>
<div class="SOM_niv1"><span href="#/chap5#niv1-020" title="Link target outside of Sample">Conclusion</span></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Subject Index</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Scripture Index</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Praise for <i>Evil and the Justice of God</i></span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
<div class="SOM_pdf"><span href="#/ident11#copy1" title="Link target outside of Sample">Copyright Page</span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?1ba7f76f